export default __webpack_public_path__ + "static/media/calendar-i.93e6ddbc.svg";